<template>
  <div class="members">
    <div class="Membersdiv">
      <div class="Members">
        <div class="memberintro">
          <h1>MEMBERS</h1>
          <div>
            <div class="memberinfo">
              <div class="memberimg">
                <img src="/img/yoshidahiroshi.png" alt>
              </div>
              <div class="membertext">
                <h2>吉田博 (Vocal) - J-POP JAM代表 -</h2>
                <p>
                  1980/9/28 福岡県出身。
                  早稲田大学政治経済学部 経済学科卒。
                  <br>
                  <br>2010年 久保田利伸全国ツアー ”Timeless Fly”に
                  日本人男性として初めてコーラスメンバーとして参加。
                  ライブ中Michael Jackson “Human Nature”を歌い、注目を浴びる。
                  <br>
                  <br>2011年 ソングライターとして、西野カナ”Esperanza”
                  （日本レコード大賞優秀作品賞受賞）をはじめ、
                  “Beloved”（ＣＸ系「グータンヌーボ」テーマ・ソング）
                  ”Clap Clap!!”（フジテレビ「めざましどようび」テーマ・ソング）
                  の他、多数の作曲アレンジ等に携わり、同年クリスマスライブにて
                  西野カナ本人と”A whole New world”をデュエット。
                  <br>
                </p>
                <div class="grad-wrap">
                  <input id="trigger1" class="grad-trigger" type="checkbox">
                  <label class="grad-btn" for="trigger1">
                    もっと見る&nbsp;
                    <i class="fas fa-angle-down"></i>
                  </label>
                  <div class="grad-item">
                    2012年 ソロ活動として初の
                    アコースティックギター弾き語りでの全国ツアーを敢行。
                    初ツアーでありながら全国全都道府県、
                    87カ所、105ステージに及ぶ行程を成功させる。
                    <br>
                    <br>コーラス出演イベント等：
                    ap bank fes 2010（つま恋）/J-wave Live 2010（代々木第一体育館）/Beatconnection 2010(横浜アリーナ)/FNS歌謡祭 2010(フジテレビ)/SONGS(NHK)/kanayan christmas 2011 (パシフィコ横浜)/堂本光一ツアー”Gravity”(大阪城ホール)/”Spiral” 嵐ツアー”LOVE”(東京ドーム、福岡ドーム)/”ARASHI BLAST in Miyagi”(宮城スタジアム)/”Japonism”(福岡ドーム)/
                    2016年AKB48、乃木坂46へ楽曲提供。
                    <br>
                    <br>『LIVEARTIST』代表
                    <a
                      href="http://liveartist.info/"
                      target="_blank"
                    >http://liveartist.info/</a>
                  </div>
                </div>
              </div>
            </div>

            <hr>

            <div class="memberinfo2">
              <div class="memberimg2">
                <img src="/img/Members_Kanbara.png" alt>
              </div>
              <div class="membertext2">
                <h2>蒲原彰利 (Vocal)</h2>
                <p>
                  1987年1月14日生まれ、東京都出身。
                  <br>Akitoshi-KamberLand(アキトシ・カンバーランド)名義て゛シンガー&ソングライターとして活動。 ブラックミュージックのエッセンスとPopな感性、
                  メッセージ性のあるハートフルな楽曲、 ソウルフルで繊細な声を武器に、多くの観客をHappyな世界へと導く。
                  <br>
                  <br>『GUSH-The Groove Usher-』(ガッシュ・ザ・グルーヴ アッシャー)のリーダーとしても活動している。第一線で活躍するダンサーとの[Specialコラボショーケース]、生バンドDJを体現した[GUSHAAAN TIME]など、『生音×ダンス』を一つの『エンターテインメント空間』 として発信している。
                  <br>
                  <br>HP
                  <a href="http://grooveusher.com/" target="_blank">http://grooveusher.com/</a>
                  <br>[Instagram] akitoshi0114
                  <br>
                </p>
                <div class="grad-wrap">
                  <input id="trigger2" class="grad-trigger" type="checkbox">
                  <label class="grad-btn" for="trigger2">
                    もっと見る&nbsp;
                    <i class="fas fa-angle-down"></i>
                  </label>
                  <div class="grad-item">
                    【略歴】
                    <br>2003年 ギター & ゴスペルを始める
                    <br>2009年 ヤマハ音楽院 Vocal科 卒業
                    <br>2012年 GUSH 1rdアルバム「Groove」リリース
                    <br>2012年 1st CDアルバム「Welcome to KamberLand」、シングル「Moon Light Party」をリリース 2014年 角松敏樹全国ツアー Choirとして参加。
                    <br>2015年 PlayStationRVita アイドル育成ゲーム『I Doll U』主題歌にコーラス参加
                    <br>2015年 ライヴ会場限定シングル「Non Stop Worker MAJIME」リリース
                    <br>2015年 「もしクワ3」@東京キネマ倶楽部 イベントプロデュース
                    <br>2016年 GUSH 2ndアルバム「TOY BOXリリース
                    <br>2016年「MOSHIJO」@東京キネマ倶楽部 イベントプロデュース (コーラスアレンシ゛&演出監修)
                    <br>2017年 短編映画「AKASHI」(監督,主演 / 吉田真由美) 楽曲提供、BC STORYHIVE グランプリ受 賞
                    (カナダ航空 飛行機機内でも上映され、各映画祭にノミネートされる)
                    <br>2017年 Versailles 武道館公演 Choirとして参加 & コーラスアレンジ監修
                    <br>2017年 角松敏樹全国ツアー Choirとして参加。
                    <br>2017年 桑田佳祐「若い広場」Music Video 出演
                    <br>2017年 GUSH 3rdアルバム「GOTF」リリース
                    <br>2017年 楽器メーカー”KORG”とエンドース契約を結ぶ。『TRINITY DANCE CENTER』PVに楽曲提供&出演。(GUSH -The Groove Usher-)
                    <br>2018年 B.A.P JAPAN 9TH SINGLE『HANDS UP』にガイドボーカルとして参加
                    <br>2018年 HALO Japan 3rd. Single『LIAR』にコーラスとして参加
                    <br>2018年 KAMIJO 6th Single 『Nosferatu』に、コーラス&コーラスアレンジ監修として参加 (Be Choir名義)
                    <br>
                    <br>アーティスト活動の他にも、ボイストレーナー、コーラス・レコーディング業、仮歌、作詞作曲、イベントプロデュース、ブライダル歌手、 etc...幅広い音楽活動をしている。
                  </div>
                </div>
              </div>
            </div>

            <hr>

            <div class="memberinfo2">
              <div class="memberimg2">
                <img src="/img/Members_miyamotoken.png" alt>
              </div>
              <div class="membertext2">
                <h2>宮本憲 (Guitar)</h2>
                <p>
                  1982年11月19日 男 A型 大阪出身
                  <br>
                  <br>■好きな音楽
                  <br>Funk、Jazz、R＆B、Blues、Pops等々
                  リズムの気持ち良い音楽。
                  <br>
                  <br>■略歴
                  <br>10歳でフルート、15歳でギターを始める。
                  大学在学中ギターを藤ジャズスクールにて田井泰弘氏に師事。
                  大学を中退後AN MUSIC SCHOOL京都校に入学。
                  ギターを小嶋利勝氏に、アンサンブルを堀尾哲二氏、西野やすし氏に師事する。
                  <br>同校を卒業後ヤマハPMS講師の資格を取得、ギター講師として稼働する。
                  <br>
                </p>
                <div class="grad-wrap">
                  <input id="trigger3" class="grad-trigger" type="checkbox">
                  <label class="grad-btn" for="trigger3">
                    もっと見る&nbsp;
                    <i class="fas fa-angle-down"></i>
                  </label>
                  <div class="grad-item">
                    2012年活動の拠点を東京へ移し、関東・関西でライブ、セッション、サポートその他演奏活動を行っている。音楽ジャンルを問わず幅広く活動中。
                    <br>中村亮 TrickStewart Band、Little Glee Monster etc…
                    様々なアーティストのライヴ、レコーディングのサポートを手がけ、
                    Hommesock、朝岡周& theJack Bandのメンバーとしても活動する。
                    <br>
                    <br>Twitter @miyamotoken
                  </div>
                </div>
              </div>
            </div>

            <hr>

            <div class="memberinfo2">
              <div class="memberimg2">
                <img src="/img/fujitayoshio.jpg" alt>
              </div>
              <div class="membertext2">
                <h2>藤田義雄 (Guitar)</h2>
                <p>
                  "妖刀猫背"の異名を持つギタリスト。
                  <br>圧倒的なスキルとグルーヴ、ステージ上で繰り広げる破壊的なパフォーマンスで見る者全てを魅了する。
                  <br>
                  <br>RADIOFISH、山本沙綺etcの数多くのアーティストサポートやHANZI BAND／GUSH / THE ACTION TICKET／Niard(冬眠中)でも活動。涙脆く義理堅い雄。
                  <br>
                  <br>twitter @youtounekoze
                  <br>
                  <br>
                </p>
              </div>
            </div>

            <hr>

            <div class="memberinfo2">
              <div class="memberimg2">
                <img src="/img/yamakyo.png" alt>
              </div>
              <div class="membertext2">
                <h2>山本恭平</h2>
                <p>
                  活動名はやまきょう
                  <br>音楽一家に育ちBeatlesやMichaelJacksonなどの音楽に親しみ、ギターを始める。
                  <br>ギタリスト古川昌義氏、安部一城氏に師事。中央大学を卒業後は中学校の社会科教師やパソコン販売の仕事を経て、ギタリストとしての仕事を始める。
                  <br>
                  <br>SE7EN、Stylistics、Three Degreesのツアーに参加。フジテレビ昼ドラの挿入曲や、ミュージカルなどでも演奏。サポート演奏、自身のリーダーライヴを中心に活動している。
                  <br>
                </p>
              </div>
            </div>

            <hr>

            <div class="memberinfo2">
              <div class="memberimg2">
                <img src="/img/tanakaayami.png" alt>
              </div>
              <div class="membertext2">
                <h2>田中 綾美 (Piano)</h2>
                <p>
                  11月13日生 山羊座 O型
                  <br>ビールとサーモンとラーメンが大好き！
                  あとタモリさんが大好き！
                  <br>
                  <br>4歳の頃からクラシックピアノを習い始め、小学一年生から作曲を始める。
                  その後オリジナル曲で弾き語りをするようになり、
                  高校生バンド大会YHMFの決勝大会に二度出場。横浜アリーナにて演奏する。
                  音楽学校に進学し、クラシック、ジャズ、作曲、アンサンブルなどを勉強。
                  卒業後は、ピアノ、キーボード、ボーカルを担当する自身のバンド活動（Carnavacation、Fish、CoplaNotes）をはじめ、
                  ピアニスト、キーボーディスト、ピアノ講師、また作編曲家として活動している。
                  <br>
                  <br>Twitter : @TanakaAyami
                </p>
              </div>
            </div>

            <hr>

            <div class="memberinfo2">
              <div class="memberimg2">
                <img src="/img/haradasou.png" alt>
              </div>
              <div class="membertext2">
                <h2>原田ソウ (Bass)</h2>
                <p>
                  担当:Bass 出身地:神奈川県
                  <br>7月6日生まれ。 蟹座Ｏ型。
                  <br>
                  <br>親に勧められたピアノ教室をかたくなに拒みつつ、
                  テレビやゲームの音楽を覚えまくるという、ひねくれた幼少時代を過ごす。
                  Tubaから低音に興味を持ち、17歳でベースを始める。
                  高校卒業後、洗足音楽大学Jazz科に入学。
                  納浩一、岡田治郎、水谷浩章各氏に師事。
                  <br>
                  <br>R&B、Hip-Hop、Club Music、Funk、JAZZ、POPS、ROCK、サウンドトラック、クラシックなど、ジャンルを越えてピンポイント狙いのWindingな嗜好を持つ。
                  <br>Hommesick、朝岡周 & theJack Band、GUSHのでの活動の他、
                  様々なアーティストのサポート、レコーディング等で活躍している。
                  <br>
                  <br>twitter : @sou_windingbass
                </p>
              </div>
            </div>

            <hr>

            <div class="memberinfo2">
              <div class="memberimg2">
                <img src="/img/otsumakoto.png" alt>
              </div>
              <div class="membertext2">
                <h2>大津 惇 (Drums)</h2>
                <p>
                  担当:Drums
                  <br>1990年7月30日生まれ。幼少期の10年間を
                  米国ミシガン州デトロイトで過ごす。
                  <br>帰国後、2006年にYamaha Big Wave Orchestraに加入。同バンドでRichie Cole(sax)、Randy Brecker (tp)らと共演。
                  <br>慶應義塾大学進学後、自身のバンド
                  「大津カルテット」が六大学音楽FES' 2010
                  決勝大会において最多動員賞受賞。
                  <br>2また、2012年に加入した観客動員総数のべ8,000人以上のダンサー×生バンドコラボショーケース団体WEFUNKではCLUB CITTA’/
                  BLITZ YOKOHAMA/ZEPP TOKYOなどで
                  毎年公演活動を行う。
                  <br>2016年にはTokyo MX系TVアニメ『STEINS;GATE』牧瀬紅莉栖役の
                  声優/歌手 今井麻美氏のソロツアー
                  ‘Words of GRACE'全国ツアーに参加。
                  <br>2018年8月には同アニメEDテーマ
                  「World-Line」のシングルカップリング曲に自身が作詞作編曲し、ドラムも担当した
                  「アメノアトニ~Brighter Days Ahead~」が
                  収録され、好評を博した。
                  <br>米国の文化を色濃く感じる強力なビートと
                  テクニックで国内外のジャズ/R&B界の
                  トップミュージシャンとの共演を続ける他、
                  ロックやポップスに至るまでジャンルに
                  捉われない演奏が今をときめく。
                  <br>【共演歴】
                  マリーン/Jay/Charito/Maya Hatch/Grace Mahya/Hanah Spring/市原ひかり/黒田卓也/Masa Kohama/Keith Middleton (from STOMP NYC)/
                  Aaron Marcellus (American Idol)/Tea/
                  日野JINO賢二/日野皓正/TOKU/宮下智/
                  ユッコ・ミラー/Hiro-a-key/KOTETSU/岩永真奈/Randy Brecker/Richie Cole/
                  Isaiah Sharkey (D'Angelo/Lalah Hathaway)/
                  Robert Vally (Bobby Caldwell)/
                  Mark Mcmillen (Bobby Caldwell)/
                  今井麻美(from STEINS;GATE/アイドルマスター)/
                  高橋りな(ミュージカル:ダンガンロンパ)/
                  井澤巧麻(ミュージカル:テニスの王子様)
                  他多数
                </p>
                <div class="grad-wrap">
                  <input id="trigger4" class="grad-trigger" type="checkbox">
                  <label class="grad-btn" for="trigger4">
                    もっと見る&nbsp;
                    <i class="fas fa-angle-down"></i>
                  </label>
                  <div class="grad-item">
                    大学卒業後は、ドラマーとしてアーティストのライブやレコーディングのサポート活動を行うとともに作編曲活動・その他音楽制作業務なども行っている。
                    ジャズドラマーとしてのバックボーンを持ちつつ、そのダンサブルでタイトなビートはジャンルの壁を超え、今をときめく。
                    <br>
                    <br>サポートアーティスト)
                    Grace Mahya、日野賢二、岩永真奈、Yucco Miller、Tea、
                    掌幻(ex フリースタイルダンジョン)、TOMOMI、今井麻美 etc..
                    <br>Hommesock、朝岡周& theJack Band、Noah Send A Black Mail、GUSHのメンバーとしても活動する。
                    <br>
                    <br>twitter @freedomakoto_ds
                  </div>
                </div>
              </div>
            </div>

            <hr>

            <div class="memberinfo2">
              <div class="memberimg2">
                <img src="/img/moritakuya.png" alt>
              </div>
              <div class="membertext2">
                <h2>森 拓也 (Drums)</h2>
                <p>
                  ドラマー&パーカッショニスト。
                  <br>12月8日 滋賀県生まれ / B型 射手座
                  <br>妻子持ち 猫背 酒飲み カレー好き
                  <br>
                  <br>小学生の頃に父親に連れられて観に行った??ベンチャーズのコンサートで??ドラマーに「オー、ハンサムボーイ」??と声を掛けられたことを機に?、勘違いの人生を歩み始める。?
                  <br>2008年より拠点を東京に移し、ライヴ・レコーディングの他、ミュージカルや舞台の劇伴の生演奏などを経験。
                  <br>
                  <br>現在は演奏家としてだけでなく作編曲家としての顔も併せ持つ。
                  CANOPUS、ASPR エンドーサー。
                  <br>
                  <br>■ 森拓也 公式ブログ Powered by LINE
                  <a
                    href="https://lineblog.me/moritakuya/"
                    target="_blank"
                  >https://lineblog.me/moritakuya/ target</a>

                  <br>
                  <br>twitter @takuyamori_drum
                </p>
              </div>
            </div>

            <hr>

            <div class="memberinfo2">
              <div class="memberimg2">
                <img src="/img/staff.png" alt>
              </div>
              <div class="membertext2">
                <h2>JAM STAFF（谷さん・MIMU・CHIAKI・NORITO）</h2>
                <p>
                  J-POP JAMに欠かせないバックスタッフメンバー達。
                  <br>
                  <br>企画・広報・デザイン制作・当日運営等、
                  回を増すごとにパワーアップするこのイベントをサポートしています。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: "members"
};
</script>

<style>
/* members.html------------------------------------------------------- */
.Membersdiv {
  background: url(/img/gray_band2.png);
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: cover;
  margin-top: 0px;
  padding: 140px 0px 80px 0px;
}

.Members {
  background-color: rgba(255, 249, 231, 0.7);
  padding: 30px 0px 50px;
  border-radius: 12px;
  max-width: 900px;
  margin: 0 auto;
  border-top: 80px;
}

.memberintro h1 {
  position: absolute;
  margin-left: -55px;
  margin-top: 5px;
  left: 50%;
  color: #000000;
  font-family: Helvetica;
  font-size: 24px;
  line-height: 29px;
  border-bottom: solid 6px black;
  padding-bottom: 5px;
}

.memberinfo {
  padding-top: 40px;
  display: flex;
}

.memberimg img {
  margin-left: 70px;
  margin-top: 70px;
}

.membertext {
  margin-left: 40px;
  margin-top: 70px;
}

.membertext h2 {
  color: #000000;
  font-family: "Hiragino Kaku Gothic Pro";
  font-size: 15px;
  line-height: 23px;
  font-weight: bold;
}

.membertext p {
  margin-right: 70px;
  color: #333333;
  font-family: "Hiragino Kaku Gothic Pro";
  font-size: 13px;
  line-height: 22px;
  margin-top: 15px;
}

/* もっと見るをクリックしたときのテキスト------- */
.grad-wrap {
  margin-right: 70px;
  color: #333333;
  font-family: "Hiragino Kaku Gothic Pro";
  font-size: 13px;
  line-height: 22px;
  margin-top: 15px;
}

.grad-btn {
  margin-left: 43%;
}

.grad-item {
  position: relative;
  overflow: hidden;
  height: 0px; /*隠した状態の高さ*/
}

.grad-item::before {
  display: block;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
}
.grad-trigger {
  display: none; /*チェックボックスは常に非表示*/
}
.grad-trigger:checked + .grad-btn {
  display: none; /*チェックされていたら、grad-btnを非表示にする*/
}
.grad-trigger:checked ~ .grad-item {
  height: auto; /*チェックされていたら、高さを戻す*/
}
.grad-trigger:checked ~ .grad-item::before {
  display: none; /*チェックされていたら、grad-itemのbeforeを非表示にする*/
}

.fas fa-angle-down {
  font-size: 15px;
}

/* メンバー二人目以降----------------- */
.memberinfo2 {
  padding-top: 30px;
  display: flex;
}

.memberimg2 img {
  margin-left: 70px;
}

.membertext2 {
  margin-left: 40px;
}

.membertext2 h2 {
  color: #000000;
  font-family: "Hiragino Kaku Gothic Pro";
  font-size: 15px;
  line-height: 23px;
  font-weight: bold;
}

.membertext2 p {
  margin-right: 70px;
  color: #333333;
  font-family: "Hiragino Kaku Gothic Pro";
  font-size: 13px;
  line-height: 22px;
  margin-top: 15px;
}

/* スマホ用members.html */
@media (max-width: 767px) {
  .Membersdiv {
    padding-bottom: 60px;
    padding-top: 75px;
    background-position: -355px center;
    background-size: cover;
    width: auto;
    height: auto;
  }

  .Members {
    margin: 0 15px;
    max-width: 900px;
    padding-bottom: 40px;
  }

  .memberintro h1 {
    font-size: 18px;
    margin-left: -40px;
  }

  .memberinfo {
    display: block;
  }

  .memberimg {
    text-align: center;
  }

  .memberimg img {
    margin-left: 0;
    margin-top: 50px;
  }

  .membertext {
    margin-left: 7px;
    margin-right: 7px;
    margin-top: 45px;
  }

  .membertext h2 {
    text-align: center;
    font-size: 13px;
  }

  .membertext p {
    margin-right: 0;
    font-size: 13px;
  }

  .grad-wrap {
    margin-right: 20px;
  }

  .memberinfo2 {
    padding-top: 0;
    display: block;
  }

  .memberimg2 {
    text-align: center;
  }

  .memberimg2 img {
    margin-left: 0;
  }

  .membertext2 {
    margin-left: 7px;
    margin-right: 7px;
    margin-top: 45px;
  }

  .membertext2 h2 {
    text-align: center;
    font-size: 13px;
  }

  .membertext2 p {
    margin-right: 0;
    font-size: 13px;
  }
}
</style>

